import { render, staticRenderFns } from "./PaymentInstruction.vue?vue&type=template&id=39c33056&"
import script from "./PaymentInstruction.vue?vue&type=script&lang=js&"
export * from "./PaymentInstruction.vue?vue&type=script&lang=js&"
import style0 from "./PaymentInstruction.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports